module.exports = __webpack_public_path__ + "static/logo_big_ukraine-218bdb457ecf4563538f59cd741cac0d.png";